<template>
  <section
    v-if="variants.v1 === variant"
    class="n-section-primary"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="tw-text-black">
      <div
        v-html="vars.titleHtml"
        class="tw-mb-10 tw-mr-auto tw-flex tw-items-start tw-justify-start tw-gap-3 tw-text-start"
      ></div>
      <div class="tw-flex tw-flex-col tw-gap-6 lg:tw-flex-row">
        <div
          v-for="(reason, index) in reasons"
          :key="`whysection-reason-${index}`"
          class="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-4 tw-bg-white tw-p-7 tw-text-center"
        >
          <nuxt-img :src="reason.icon" class="tw-max-w-16 lg:tw-w-20 lg:tw-max-w-none" />
          <h4 class="tw-mb-4 tw-h-1/6">{{ reason.title }}</h4>
          <p class="tw-line-clamp-[10] lg:tw-min-h-[180px]">
            {{ reason.description }}
          </p>
          <nuxt-link
            v-if="reason.button_link"
            :to="reason.button_link"
            :class="`n-${reason.button_type} tw-mt-auto`"
            style="color: var(--c-primary)"
            ><h5>{{ reason.button_label }}</h5></nuxt-link
          >
        </div>
      </div>
    </div>
  </section>

  <section
    v-if="variants.v2 === variant"
    class="n-section-primary"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="n-title-primary tw-text-center">
      <div v-html="vars.titleHtml" class="tw-mx-auto tw-mb-12"></div>
      <div class="tw-flex tw-flex-col tw-gap-6 lg:tw-flex-row">
        <MotionGroup
          preset="popVisibleOnce"
          :duration="800"
          is="div"
          v-for="(reason, index) in reasons"
          :key="`whysection-reason-${index}`"
          class="tw-relative tw-flex tw-w-full tw-max-w-xl tw-flex-col tw-items-center tw-gap-x-4 tw-gap-y-6 tw-overflow-hidden tw-border-b-2 tw-bg-white tw-p-7 tw-text-center tw-transition-all tw-duration-500 after:tw-absolute after:tw-bottom-[-600px] after:tw-left-0 after:tw-z-0 after:tw-h-full after:tw-w-full after:tw-bg-[var(--c-input)] after:tw-duration-500 after:tw-content-[''] hover:tw-translate-y-[-5px] hover:tw-shadow-[var(--box_shadow)] hover:after:tw-bottom-0 lg:tw-min-h-[424px]"
          style="
            border-color: var(--c-secondary);
            border-top-left-radius: var(--rounded);
            border-top-right-radius: var(--rounded);
          "
        >
          <nuxt-img :src="reason.icon" class="tw-z-10 tw-max-w-16 lg:tw-w-20 lg:tw-max-w-none" />
          <h4 class="n-title-primary tw-z-10 tw-mb-4 tw-h-1/6 !tw-font-normal">{{ reason.title }}</h4>
          <p class="tw-z-10 tw-line-clamp-[10] tw-text-black">
            {{ reason.description }}
          </p>
        </MotionGroup>
      </div>
    </div>
  </section>

  <section
    v-if="variants.v3 === variant"
    class="n-section-primary tw-relative"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <img
      v-if="vars.mascottEnabledBool"
      :src="vars.mascottImage"
      alt="mascott"
      class="tw-pointer-events-none tw-absolute -tw-top-[65px] tw-right-1/2 tw-w-32 tw--scale-x-100 md:-tw-top-[80px] md:tw-w-[160px]"
    />
    <div
      v-if="company.company_key === 'townandcityhomes'"
      class="tw-pointer-events-none tw-absolute tw-bottom-0 tw-left-0 tw-hidden lg:tw-block"
    >
      <span
        ><svg width="419" height="445" viewBox="0 0 419 445" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_9_2220)">
            <path
              d="M403.2 237.4C378.6 199.8 332.1 189.3 298.1 195.6C255.7 203.5 224.3 239.5 211.1 279.9C204.7 300.1 202.9 321.4 206.5 340.8C211.1 365.1 223.6 383 233.2 394.1C234.5 395.3 234.8 396.9 234.2 397.7C233.7 398.4 232.7 398.4 232 398.3C230.3 398 229.3 396.8 228.1 395.8C226.9 394.8 225.9 393.6 224.7 392.4C222.5 390.2 220.4 387.9 218.3 385.4C214.1 380.6 210.4 375.5 206.9 370.3C203.5 365.1 200.5 359.5 197.9 353.8C195.2 348.1 193 342.3 191.2 336.3C189.4 330.3 187.9 324.2 187 318C186 311.9 185.4 305.6 185.2 299.3C185.1 293 185.4 286.7 185.9 280.4V279.9C186.7 273.8 187.8 267.6 189.3 261.6C190.1 258.6 191 255.8 191.8 252.9C194.3 245.3 198.5 238.2 201.1 230.7L137.5 167.7C71.3 195.4 66.2 197.5 0 225V429.1C0 431 0.4 432.8 1.2 434.6C3.3 440.1 8.7 444 15 444H333.8C333.6 444 333.5 443.8 333.3 443.7C326.4 439.7 309.8 428.3 301.1 407C290.2 380 295.7 345.9 318.8 324.3C323.1 320.1 328.1 316.7 333.3 314C357.9 300.5 389.8 301.7 414.9 319.1C416.8 311.9 426.4 272.7 403.2 237.2"
              fill="#2D1559"
            />
            <path
              d="M190.9 180.5C190.9 182.2 190.9 183.8 190.7 185.5H227.7C227.5 183.8 227.5 182.2 227.5 180.5C227.5 140.7 255.5 108.6 290.1 108.6C324.7 108.6 295.6 108.8 298.3 109.3V0C270.2 0 247.2 22.9 247.2 51.2H171C171 22.9 148.1 0 119.9 0V109.3C122.6 108.8 125.3 108.6 128.1 108.6C162.7 108.6 190.7 140.7 190.7 180.5"
              fill="#2D1559"
            />
          </g>
          <defs>
            <clipPath id="clip0_9_2220">
              <rect width="418.5" height="444.2" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </span>
    </div>
    <div class="tw-mx-auto tw-mb-12">
      <h2 style="color: var(--c-text_secondary)">{{ vars.titleText }}</h2>
    </div>
    <div class="tw-flex tw-flex-col tw-gap-6 lg:tw-flex-row">
      <MotionGroup
        preset="popVisibleOnce"
        :duration="800"
        is="div"
        v-for="(reason, index) in reasons"
        :key="`whysection-reason-${index}`"
        class="tw-relative tw-flex tw-w-full tw-max-w-xl tw-flex-col tw-items-start tw-gap-x-4 tw-gap-y-6 tw-overflow-hidden tw-p-7 tw-text-start tw-transition-all tw-duration-500 hover:tw-translate-y-[-5px] hover:tw-shadow-[var(--box_shadow)] lg:tw-min-h-[424px]"
        style="color: var(--c-text_secondary); background-color: var(--c-section_tertiary)"
      >
        <nuxt-img :src="reason.icon" class="tw-z-10 tw-max-w-16 lg:tw-w-20 lg:tw-max-w-none" />
        <h5 style="color: var(--c-text_secondary)" class="tw-z-10 tw-mb-4 tw-h-1/6">{{ reason.title }}</h5>
        <p class="tw-z-10 tw-line-clamp-[10]" style="color: var(--c-text_secondary)">
          {{ reason.description }}
        </p>
      </MotionGroup>
    </div>
  </section>
</template>

<script lang="ts">
import { MotionGroup } from '#components';
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'WhySection',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },
    };
  },
  computed: {
    reasons() {
      return this.groupedVariables.reasons;
    },
  },
});
</script>
